import { pluralize } from '@gonfalon/format/pluralize';

/**
 * Convert milliseconds to a human-readable duration string.
 * E.g., 90000000 -> "1 day, 1 hour"
 */
export function convertMsToDisplayDuration(ms: number): string {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  const hours = Math.floor((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));

  const parts: string[] = [];
  if (days > 0) {
    parts.push(`${days} ${pluralize(days, 'day', 'days')}`);
  }
  if (hours > 0) {
    parts.push(`${hours} ${pluralize(hours, 'hour', 'hours')}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${pluralize(minutes, 'minute', 'minutes')}`);
  }

  return parts.length > 0 ? parts.join(', ') : '0 minutes';
}
